import { TabData, TabName } from '@/components/organisms/BrowseBy/BrowseBy'
import { isNonEmptyObject } from '@/utils/checks'

export const shouldShowShowMore = (
  items: Record<TabName, TabData>,
  activeTab: TabName,
  showMore: boolean,
  currentThreshold: number
): boolean => {
  return (
    !showMore &&
    isNonEmptyObject(items[activeTab]) &&
    items[activeTab].links?.length > currentThreshold
  )
}
